import { Injectable } from '@angular/core'
import { ICandidateApplicationUpdateStage } from '@candidate/app/models/candidate-job-update.model'
import { AtLeast } from '@engineering11/types'
import { omit } from '@engineering11/utility'
import { Observable } from 'rxjs'
import { ApplicationUpdateStageRepository } from './application-update-stage.repository'

@Injectable({ providedIn: 'root' })
export class ApplicationUpdateStageService {
  constructor(private applicationUpdateStageRepository: ApplicationUpdateStageRepository) {}

  getByUserAndJobPost(userId: string, jobPostId: string): Observable<ICandidateApplicationUpdateStage | undefined> {
    const id = buildApplicationUpdateStageId({ candidateId: userId, jobPostId })
    return this.applicationUpdateStageRepository.get(id)
  }

  upsert(model: AtLeast<ICandidateApplicationUpdateStage, 'jobPostId' | 'candidateId'>) {
    const modelToSave = { ...model, id: buildApplicationUpdateStageId(model) }
    const sanitizedModel = modelToSave.resumeAttachment
      ? { ...modelToSave, resumeAttachment: omit(modelToSave.resumeAttachment, 'signedURL') }
      : { ...modelToSave }

    return this.applicationUpdateStageRepository.upsert(sanitizedModel)
  }
}

export function buildApplicationUpdateStageId(idData: Pick<ICandidateApplicationUpdateStage, 'jobPostId' | 'candidateId'>) {
  return `${idData.candidateId}_${idData.jobPostId}`
}
